export default {
      id: "ic_nav_multiple_match-usage",
      viewBox: "0 0 38 30",
      url: "/" + "images/icons.3.109.2.svg#ic_nav_multiple_match-usage",
      toString: function () {
        return this.url;
      }
    }